export default __webpack_public_path__ + "static/media/trade.c35bb2af.svg";